<div
  class="ui-dt__action-menu"
  [class.ui-dt__action-menu--above]="state().openAbove"
  [style.top.px]="state().top"
  [style.left.px]="state().left"
  (click)="$event.stopPropagation()"
>
  @for (action of items(); track action.key) {
    <button
      type="button"
      class="ui-dt__action-item"
      [class.ui-dt__action-item--destructive]="action.destructive"
      (click)="actionSelect.emit(action)"
    >{{ action.label }}</button>
  }
</div>

